import React, { useMemo } from 'react';
import { Dropdown, DropdownOption } from '@ihsm/ui-shared';
import { useAppSelector } from 'state/store';

export const BenchmarkDropdown: React.FC = () => {
  const { benchmarkList } = useAppSelector((state) => state.benchmarkState);

  const options: DropdownOption[] = useMemo(
    () =>
      benchmarkList.map((bench) => ({
        displayText: bench,
        value: bench,
      })),
    [benchmarkList]
  );

  const selectedBenchmark = useMemo(() => {
    if (!benchmarkList || benchmarkList.length <= 0) return '';

    return benchmarkList[0];
  }, [benchmarkList]);

  return (
    <Dropdown
      labelText="Benchmark"
      value={selectedBenchmark}
      options={options}
      onChange={() => {}}
      disabled
    />
  );
};
